var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccountAvatar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 38,
    viewBox: "0 0 36 38",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.11 27.803l-6.76-4.053A12.6 12.6 0 0118 26.917a12.6 12.6 0 01-8.35-3.167l-6.76 4.053a4.77 4.77 0 00-2.307 4.073V38h34.833v-6.124a4.77 4.77 0 00-2.307-4.073zM18 23.75a9.5 9.5 0 01-9.5-9.5V9.5A9.5 9.5 0 0118 0a9.5 9.5 0 019.5 9.5v4.75a9.5 9.5 0 01-9.5 9.5z"
  })));
}
export default SvgAccountAvatar;